<template>
  <v-checkbox
    v-model="value"
    style="margin:-3px !important;padding:0 !important;text-align: center !important"
    v-bind="$props"
    @change="$emit('input',$event)"
  />
</template>

<script>
  export default {
    name: "PsCheckbox",
    props: {
        value: {
            type: Boolean,
            required: true
        },
      color: {
        type: String,
        required: true
      },
      disabled: {
        type: Boolean,
        required: false
      }
    }
  };
</script>
<style>
  psCheckBox {
    margin:-3px !important;
    padding:0px !important;
    text-align: center !important
  }
</style>
